import { GridController } from 'controller/gridcontroller.js';
import logger from '@/plugins/logger.js';

export default class ExtendedGridController extends GridController {
  constructor (controller, commands) {
    logger.log('editgridcontroller', controller, commands);
    super(controller);
    this.commands = commands;
  }

  GetFlexData (obj) {
    if (this.commands && this.commands.GetFlexData) {
      return this.execute(this.commands.GetFlexData, obj);
    }
  }
  execute (webmethod, params) {
    let uri = this.getWebMethodUri(webmethod);
    let p = params;
    if (webmethod.parameters) {
      p = { ...webmethod.parameters, ...params };
    }
    return this.api.Post(uri, p);
  }

  getWebMethodUri (webmethod) {
    return `${webmethod.controller}/${webmethod.method}`;
  }
}
